module.exports = __webpack_public_path__ + "img/ss3 copy.ef244b0c.png";